import { useEffect } from 'react';
import type { SurveyPaginationContext } from '../types';

export function useResetPageStartTime(context: SurveyPaginationContext): void {
  const { currentPageIndex, paginationRefs } = context;

  useEffect(() => {
    if (paginationRefs.current) {
      paginationRefs.current.pageStartTime = performance.now();
    }
  }, [currentPageIndex, paginationRefs]);
}
